import axios from "axios";
const baseUrl = process.env.VUE_APP_API_URL;
const baselineMachineUrl = process.env.VUE_APP_BASELINE_MACHINE_URL;

export default {
    async getStatus() {
        let response = await axios.post(baseUrl + '/ec2/status');
        return response.data;
    },
    async startInstance() {
        let response = await axios.post(baseUrl + '/ec2/start');
        return response.data;
    },
    async stopInstance() {
        let response = await axios.post(baseUrl + '/ec2/stop');
        return response.data;
    },
    async getApiStatus() {
        let response = await axios.get(baselineMachineUrl);
        return response;
    }
}
